import { useFiltersState, useFiltersV2Actions } from "PFApp/components/filters_v2";
import { ProfileCard } from "PFApp/components/profile_card";
import { Flex, Stack } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import NotFoundComponent from "PFComponents/not_found/not_found";
import { SimplePagination } from "PFComponents/pagination/simple_pagination";
import { Typography } from "PFComponents/typography";
import NoProfilesIllustration from "PFTheme/graphics/illustrations/illustration-no-profiles.svg";
import { useTranslation } from "react-i18next";

import { useProfilesPageContext } from "../../context";
import css from "./profiles_cards.module.scss";

export const ProfilesCards = () => {
  const { t } = useTranslation(["translation", "profiles"]);
  const { profiles, meta, isFetching, setCurrentPage, scrollableContainerRef } = useProfilesPageContext();

  const { resetValues } = useFiltersV2Actions();
  const { areFiltersModified } = useFiltersState();

  const isAnyProfile = profiles.length > 0;
  const showEmptyState = !isFetching && !isAnyProfile;

  return (
    <div className={css.cardViewContainer}>
      {isFetching && (
        <Flex className={css.loadingOverlay} center>
          <LoadingDots circleSize="xs" circlesEnabled />
        </Flex>
      )}
      <Stack>
        {profiles.map((profile) => (
          <div key={profile.id}>
            <ProfileCard
              profile={profile.profile}
              highlights={profile.optionalFields?.highlights}
              scrollableContainerRef={scrollableContainerRef}
            />
          </div>
        ))}
        <SimplePagination
          currentPage={meta.page}
          totalPages={meta?.totalPages}
          handleClick={setCurrentPage}
        />
        {showEmptyState && (
          <NotFoundComponent
            message={t("profiles:list.noResultsMessage")}
            buttonMessage={t("profiles:list.resetFilters")}
            handleClick={areFiltersModified ? resetValues : undefined}
          >
            <NoProfilesIllustration />
            <Typography withMargin variant="h2">
              {t("profiles:list.noProfilesMatch")}
            </Typography>
          </NotFoundComponent>
        )}
      </Stack>
    </div>
  );
};
